import { useEffect, useState } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { isBMI, getMyAccountId } from "../utils/config";
import { fetchBudgets, fetchBudgetConsumption } from "../utils/budgetApi";
import { MONTHS } from "./BudgetGrid";
import BudgetProgressBar from "./BudgetProgressBar";

// Aviso de presupuesto: asignado vs consumo real del mes + este pedido, a nivel de
// TOTAL de la sucursal (suma de todas las categorias, no categoria por categoria).
// Es solo informativo — nunca deshabilita el boton de confirmar la orden (regla de
// oro del sprint: avisar, nunca bloquear la generacion de la ODC).
export default function CartBudgetWarning({ user, cartTotal }) {
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!isBMI(user) || !(Number(cartTotal) > 0)) {
            setLoading(false);
            return;
        }

        const idShipTo = user.idShipTo || 0;
        const currentMonthKey = MONTHS[new Date().getMonth()].key;
        const currentMonth = new Date().getMonth() + 1;
        const currentYear = new Date().getFullYear();

        Promise.all([
            fetchBudgets({ myaccountId: getMyAccountId(), idCustomer: user.idCustomer, idShipTo }),
            fetchBudgetConsumption({ idCustomer: user.idCustomer, idShipTo }),
        ])
            .then(([budgetRows, consumptionRows]) => {
                const asignado = (budgetRows || []).reduce(
                    (sum, r) => sum + (Number(r[currentMonthKey]) || 0),
                    0
                );

                const consumoMes = (consumptionRows || [])
                    .filter((r) => r.year1 === currentYear && r.month1 === currentMonth)
                    .reduce((sum, r) => sum + (Number(r.totalPrice) || 0), 0);

                const proyectado = consumoMes + Number(cartTotal);
                const pct = asignado > 0 ? (proyectado / asignado) * 100 : 0;

                setStatus({ asignado, consumoMes, proyectado, pct });
            })
            .catch((err) => console.error("Error verificando presupuesto de la sucursal", err))
            .finally(() => setLoading(false));
    }, [user, cartTotal]);

    if (loading || !status || status.asignado <= 0) return null;

    const isOverBudget = status.pct > 100;

    return (
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 mb-6">
            <div className="flex items-center gap-2 mb-3">
                {isOverBudget && <FaExclamationTriangle className="text-red-500" size={16} />}
                <h3 className="text-sm font-semibold text-gray-800">
                    Presupuesto de la sucursal — {new Intl.DateTimeFormat("es-EC", { month: "long", year: "numeric" }).format(new Date())}
                </h3>
            </div>

            {isOverBudget && (
                <p className="text-sm text-red-600 mb-3">
                    Este pedido excede el presupuesto asignado del mes. Puedes continuar de todas formas.
                </p>
            )}

            <BudgetProgressBar asignado={status.asignado} pct={status.pct} />
        </div>
    );
}
